<template>
  <div class="w-full max-w-[360px] flex flex-col items-center justify-center gap-4 p-4">
    <img src="@/assets/ginger-logo.svg" class="logo"/>
    <h1 class="text-7xl">404</h1>
    <h3 class="text-xl">Page Not Found</h3>  
    <Button label="Go to Home Page" @click="this.$router.push('/')" />
  </div>
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'NotFound',
  components: {
    Button,
  },
}
</script>

<style scoped>

.logo {
  width: 60px;
  height: 60px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

</style>
